import './footer.scss'
import React from 'react'
import Logo from '../Logo/Logo'
import { Link } from '../global/Link/'
import Copywrite from './Copywrite'
import { NewsletterSubscription } from '../NewsletterSubscription/NewsletterSubscription'
import { useFooterQuery } from '../../hooks/useFooterQuery'

/**
 * React component representing the desktop version of the website footer.
 *
 * @component
 * @returns {JSX.Element} - React JSX element displaying the desktop footer.
 */

const Footer = ({ logoSrc }) => {
  const data = useFooterQuery()

  return (
    <footer className="footer-desktop">
      <div className="innerContainer">
        <section>
          <div className="link-list">
            <ul>
              {data?.menu?.menuItems?.nodes.map(item => (
                <li key={item.id}>
                  <Link to={item.url}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="newsletter-container">
            <NewsletterSubscription version={'footer'} isCta={false} />
          </div>
        </section>

        <div className="line" />

        <section className="footer-copy-container">
          <Logo src={logoSrc} height="54px" />
          <Copywrite />
        </section>
      </div>
    </footer>
  )
}

export default Footer
